import React from 'react';

export default function SidebarSection({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) {
  return (
    <div className="space-y-3">
      <h3 className="dark:text-brand-light-25">{title}</h3>
      <div className="dark:text-brand-light-100">{children}</div>
      <hr className="dark:border-brand-dark-25" />
    </div>
  );
}
